import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventPenaltyFail extends DomainEvent<MatchEvent> {}
